import { Direction } from "./helpers.js";
import { WireOverlapMode } from "./wires.js";
import { GlitchInfo } from "./parsers/nccs.pb.js";
export var Layer;
(function (Layer) {
    Layer[Layer["STATIONARY"] = 0] = "STATIONARY";
    Layer[Layer["ITEM"] = 1] = "ITEM";
    Layer[Layer["ITEM_SUFFIX"] = 2] = "ITEM_SUFFIX";
    Layer[Layer["MOVABLE"] = 3] = "MOVABLE";
    Layer[Layer["SPECIAL"] = 4] = "SPECIAL";
})(Layer || (Layer = {}));
export class Tile {
    *getAllLayers() {
        if (this[Layer.STATIONARY])
            yield this[Layer.STATIONARY];
        if (this[Layer.ITEM])
            yield this[Layer.ITEM];
        if (this[Layer.ITEM_SUFFIX])
            yield this[Layer.ITEM_SUFFIX];
        if (this[Layer.MOVABLE])
            yield this[Layer.MOVABLE];
        if (this[Layer.SPECIAL])
            yield this[Layer.SPECIAL];
    }
    *getAllLayersReverse() {
        if (this[Layer.SPECIAL])
            yield this[Layer.SPECIAL];
        if (this[Layer.MOVABLE])
            yield this[Layer.MOVABLE];
        if (this[Layer.ITEM_SUFFIX])
            yield this[Layer.ITEM_SUFFIX];
        if (this[Layer.ITEM])
            yield this[Layer.ITEM];
        if (this[Layer.STATIONARY])
            yield this[Layer.STATIONARY];
    }
    get allActors() {
        return this.getAllLayers();
    }
    get allActorsReverse() {
        return this.getAllLayersReverse();
    }
    constructor(level, position, actors) {
        this.level = level;
        this.position = position;
        this.wires = 0;
        this.poweredWires = 0;
        this.wireTunnels = 0;
        this.wireOverlapMode = WireOverlapMode.CROSS;
        this.poweringWires = 0;
        ;
        [this.x, this.y] = position;
        this.addActors(actors);
    }
    findActor(func) {
        let i = 0;
        // Handle the per-layer situation first
        for (const actor of this.getAllLayers())
            if (func(actor, i++))
                return actor;
        return null;
    }
    hasLayer(layer) {
        return layer in this;
    }
    /**
     * Adds new actors to the tile, sorting everything automatically
     */
    addActors(actors) {
        actors = actors instanceof Array ? actors : [actors];
        for (const actor of actors) {
            const layer = actor.layer;
            if (!this[layer])
                this[layer] = actor;
            else {
                this[layer].despawned = true;
                this.level.despawnedActors.push(this[layer]);
                this[layer] = actor;
                this.level.addGlitch({
                    glitchKind: GlitchInfo.KnownGlitches.DESPAWN,
                    location: { x: this.x, y: this.y },
                    specifier: 1,
                });
            }
        }
    }
    removeActors(actors) {
        actors = actors instanceof Array ? actors : [actors];
        for (const actor of actors) {
            const theLayer = this[actor.layer];
            // Ignore attempts to remove a non-existant actor
            if (!theLayer)
                continue;
            if (theLayer !== actor) {
                this.level.addGlitch({
                    glitchKind: GlitchInfo.KnownGlitches.DESPAWN,
                    location: { x: this.x, y: this.y },
                    specifier: 2,
                });
                theLayer.despawned = true;
                this.level.despawnedActors.push(theLayer);
            }
            delete this[actor.layer];
        }
    }
    getNeighbor(direction, wrap = true) {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m;
        switch (direction) {
            case Direction.UP:
                return ((_b = (_a = this.level.field[this.position[0]]) === null || _a === void 0 ? void 0 : _a[this.position[1] - 1]) !== null && _b !== void 0 ? _b : null);
            case Direction.LEFT:
                if (this.x === 0 && wrap)
                    return (_d = (_c = this.level.field[this.level.width - 1]) === null || _c === void 0 ? void 0 : _c[this.y - 1]) !== null && _d !== void 0 ? _d : null;
                return ((_f = (_e = this.level.field[this.position[0] - 1]) === null || _e === void 0 ? void 0 : _e[this.position[1]]) !== null && _f !== void 0 ? _f : null);
            case Direction.DOWN:
                return ((_h = (_g = this.level.field[this.position[0]]) === null || _g === void 0 ? void 0 : _g[this.position[1] + 1]) !== null && _h !== void 0 ? _h : null);
            case Direction.RIGHT:
                if (this.x === this.level.width - 1 && wrap)
                    return (_k = (_j = this.level.field[0]) === null || _j === void 0 ? void 0 : _j[this.y + 1]) !== null && _k !== void 0 ? _k : null;
                return ((_m = (_l = this.level.field[this.position[0] + 1]) === null || _l === void 0 ? void 0 : _l[this.position[1]]) !== null && _m !== void 0 ? _m : null);
        }
    }
    getSpeedMod(other) {
        let speedMod = 1;
        for (const actor of this.getAllLayers())
            if (actor.speedMod && !actor._internalIgnores(other))
                speedMod *= actor.speedMod(other);
        return speedMod;
    }
    *getDiamondSearch(level) {
        var _a;
        const offsets = [
            [-1, -1],
            [-1, 1],
            [1, 1],
            [1, -1],
        ];
        const targets = [
            [0, -level],
            [-level, 0],
            [0, level],
            [level, 0],
        ];
        for (let currOffset = [level, 0], currTarget = 0; true; currOffset[0] += offsets[currTarget][0],
            currOffset[1] += offsets[currTarget][1]) {
            if (currOffset[0] === targets[currTarget][0] &&
                currOffset[1] === targets[currTarget][1])
                currTarget++;
            if (currTarget === 4)
                break;
            const tile = (_a = this.level.field[this.x + currOffset[0]]) === null || _a === void 0 ? void 0 : _a[this.y + currOffset[1]];
            if (tile)
                yield tile;
        }
    }
}
Layer.STATIONARY, Layer.ITEM, Layer.ITEM_SUFFIX, Layer.MOVABLE, Layer.SPECIAL;
//# sourceMappingURL=tile.js.map